/* site-footer@1: shared, progressively enhanced official notice. */
(() => {
  if (customElements.get("guru-footer-notice")) return;
  let sequence = 0;

  class FooterNotice extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener("click", (event) => {
        const trigger = event.target.closest(".guru-footer-notice__trigger");
        if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (typeof HTMLDialogElement === "undefined" || !HTMLDialogElement.prototype.showModal) return;
        event.preventDefault();
        this.openNotice(trigger);
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.closeNotice();
      this.controller?.abort();
      this.controller = null;
    }

    openNotice(trigger) {
      if (this.dialog) return;
      const dialog = document.createElement("dialog");
      dialog.className = "guru-footer-notice-dialog";
      dialog.setAttribute("aria-modal", "true");
      dialog.innerHTML = `<div class="guru-footer-notice-dialog__panel">
        <div class="guru-footer-notice-dialog__header"><h2></h2><button class="guru-footer-notice-dialog__close" type="button" autofocus><svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 6 12 12M18 6 6 18"></path></svg></button></div>
        <div class="guru-footer-notice-dialog__tools"><a class="guru-footer-notice-dialog__more"></a><button class="guru-footer-notice-dialog__zoom" type="button" aria-pressed="false"></button></div>
        <div class="guru-footer-notice-dialog__scroll"><a class="guru-footer-notice-dialog__image-link"><img width="1654" height="2339"></a></div>
      </div>`;
      const title = dialog.querySelector("h2");
      title.id = `guru-footer-notice-title-${++sequence}`;
      title.textContent = this.dataset.title;
      dialog.setAttribute("aria-labelledby", title.id);
      const close = dialog.querySelector(".guru-footer-notice-dialog__close");
      close.setAttribute("aria-label", this.dataset.close);
      const more = dialog.querySelector(".guru-footer-notice-dialog__more");
      more.href = this.dataset.url;
      more.textContent = this.dataset.more;
      const imageLink = dialog.querySelector(".guru-footer-notice-dialog__image-link");
      imageLink.href = this.dataset.url;
      // Do not let storefront navigation/prefetch intercept external information.
      more.setAttribute("data-no-instant", "");
      imageLink.setAttribute("data-no-instant", "");
      const image = imageLink.querySelector("img");
      image.alt = this.dataset.alt;
      image.src = trigger.href;
      const zoom = dialog.querySelector(".guru-footer-notice-dialog__zoom");
      zoom.textContent = this.dataset.zoom;
      zoom.addEventListener("click", () => {
        const enlarged = zoom.getAttribute("aria-pressed") !== "true";
        zoom.setAttribute("aria-pressed", String(enlarged));
        zoom.textContent = enlarged ? this.dataset.fit : this.dataset.zoom;
        imageLink.classList.toggle("is-enlarged", enlarged);
      });
      close.addEventListener("click", () => this.closeNotice());
      dialog.addEventListener("cancel", (event) => {
        event.preventDefault();
        this.closeNotice();
      });
      dialog.addEventListener("click", (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.closeNotice();
      });
      dialog.addEventListener("keydown", (event) => {
        if (event.key !== "Tab") return;
        const controls = [...dialog.querySelectorAll("a[href], button")];
        const first = controls[0];
        const last = controls.at(-1);
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      });
      this.invoker = trigger;
      this.dialog = dialog;
      this.previousOverflow = document.body.style.overflow;
      document.body.append(dialog);
      dialog.showModal();
      document.body.style.overflow = "hidden";
      close.focus({ preventScroll: true });
    }

    closeNotice() {
      if (!this.dialog) return;
      this.dialog.close();
      this.dialog.remove();
      this.dialog = null;
      document.body.style.overflow = this.previousOverflow;
      if (this.invoker?.isConnected) this.invoker.focus({ preventScroll: true });
      this.invoker = null;
    }
  }

  customElements.define("guru-footer-notice", FooterNotice);
  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll?.("guru-footer-notice").forEach((notice) => notice.disconnectedCallback());
  });
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll?.("guru-footer-notice").forEach((notice) => notice.connectedCallback());
  });
})();
